module.exports = __webpack_public_path__ + "static/media/icon-light.f8a9be6e.svg";